<!--
 * @Author: your name
 * @Date: 2019-12-27 16:23:20
 * @LastEditTime : 2019-12-30 14:49:47
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yteac:\Users\hasee\Desktop\handlephoto\src\components\sidebar.vue
 -->
<template>
  <div class="sidebar-row">
    <div class="title-col">
      <div class="title">
        <a-icon :type="iconType" class="icon" />
        <span>{{title}}</span>
      </div>
      <span class="subTitle">{{subTitle}}</span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "sidebar",
  props: {
    title: String,
    iconType: String,
    subTitle: String
  }
};
</script>
<style scoped>
.title-col {
  height: 44px;
  background: #f5f7fa;
  padding: 14px 15px;
  text-align: left;
  display: flex;
  justify-content: space-between;
}
.title {
  font-size: 14px;
  color: #000000;
  display: flex;
  align-items: center;
}
.icon {
  margin-right: 8px;
  color: #555657;
}
.subTitle {
  font-size: 10px;
  color: #adadae;
  text-align: right;
  float: right;
}
</style>
